import { default as MaterialCheckbox } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";

import "./Checkbox.scss";

type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
  label?: string;
  children?: React.ReactNode;
  className?: string;
  testId?: string;
  onChange: (event?: any) => void;
  checked?: boolean;
  disabled?: boolean;
};

const Checkbox: React.FC<CheckboxProps> = ({
  indeterminate,
  checked,
  children,
  testId = "",
  onChange,
  className,
  label,
  disabled
}: CheckboxProps) => {
  return (
    <FormControlLabel
      className="checkbox-label"
      control={
        <MaterialCheckbox
          onChange={onChange}
          indeterminate={indeterminate}
          className={`checkbox ${className}`}
          data-test-id={testId}
          checked={checked}
          style={{ color: "black" }}
          disabled={disabled}
        />
      }
      label={children}
    />
  );
};

export default Checkbox;
